import * as React from 'react';
import {
  NotificationModal,
  useOpenNotificationModal
} from 'catering/components/Modals';
import { PrimaryCta, SecondaryCta } from 'components/Buttons';
import { getOwnAlertModalButtonState } from 'styles/helpers/getSecondaryButtonState';

function BetweenMenusNotification() {
  // TODO: missing implementation
  const handlePrimaryCtaClick = () => {
    window.alert('Set A New Time');
  };

  const handleSecondaryCtaClick = () => {
    window.alert('View Menu');
  };

  return (
    <NotificationModal
      title="Items unavailable at this location"
      text="These menu items are unavailable at the time you selected. Choose a
        different time or view the menu that is available for that time."
    >
      <PrimaryCta
        label="Set A New Time"
        handleClick={handlePrimaryCtaClick}
        fullWidth
      />
      <SecondaryCta
        ownState={getOwnAlertModalButtonState()}
        sx={{ marginTop: '16px' }}
        label="View Menu"
        handleClick={handleSecondaryCtaClick}
      />
    </NotificationModal>
  );
}

export function useOpenBetweenMenusNotificationModal() {
  return useOpenNotificationModal(<BetweenMenusNotification />);
}
